import affiliates from "./affiliates";

const bdmModule = {
  namespaced: true,
  modules: {
    affiliates,
  },
};

export default bdmModule;
